export const A_LEVEL_RANK = {
  AAB_OR_LOWER: 1,
  AAA: 2,
  A_STAR_AA: 3,
  A_STAR_A_STAR_A: 4,
  ABOVE_A_STAR_A_STAR_A: 5,
  OTHER_OR_NON_COMPARABLE: 99,
};

export const A_LEVEL_OPTIONS = [
  { value: 'all', label: 'Any requirement', maxRank: null },
  { value: 'a_star_a_star_a', label: 'A*A*A or below', maxRank: A_LEVEL_RANK.A_STAR_A_STAR_A },
  { value: 'a_star_aa', label: 'A*AA or below', maxRank: A_LEVEL_RANK.A_STAR_AA },
  { value: 'aaa', label: 'AAA or below', maxRank: A_LEVEL_RANK.AAA },
  { value: 'aab', label: 'AAB or below', maxRank: A_LEVEL_RANK.AAB_OR_LOWER },
];

export const UCAT_SCORE_MIN = 900;
export const UCAT_SCORE_MAX = 2700;

export function parseCommittedUcatScore(raw) {
  const trimmed = String(raw ?? '').trim();
  if (!trimmed) {
    return { score: null, error: null };
  }
  const n = Number(trimmed);
  if (!Number.isFinite(n)) {
    return { score: null, error: 'Enter a UCAT total between 900 and 2700.' };
  }
  if (n < UCAT_SCORE_MIN || n > UCAT_SCORE_MAX) {
    return { score: null, error: 'Enter a UCAT total between 900 and 2700.' };
  }
  return { score: n, error: null };
}

export function passesUcatFilter(school, enteredScore) {
  if (enteredScore === null) return true;

  if (
    school.filters.ucatMode === 'simple_threshold' &&
    Number.isFinite(school.filters.ucatThreshold)
  ) {
    return enteredScore >= school.filters.ucatThreshold;
  }

  return true;
}

export function passesALevelFilter(school, aLevelMaximum) {
  if (aLevelMaximum === 'all' || aLevelMaximum == null) return true;
  const option = A_LEVEL_OPTIONS.find((item) => item.value === aLevelMaximum);
  if (!option || option.maxRank == null) return true;
  const rank = school.filters?.aLevelRank;
  if (rank == null || rank === A_LEVEL_RANK.OTHER_OR_NON_COMPARABLE) return true;
  return rank <= option.maxRank;
}

export function filterMedSchools(schools, { ucatScore = null, aLevelMaximum = 'all' } = {}) {
  return (schools || []).filter(
    (school) => passesUcatFilter(school, ucatScore) && passesALevelFilter(school, aLevelMaximum)
  );
}

export function formatResultCount(count) {
  const n = Number(count) || 0;
  return n === 1 ? 'Showing 1 medical school' : `Showing ${n} medical schools`;
}

export function sortSchoolsByName(schools) {
  return [...(schools || [])].sort((a, b) =>
    String(a.name || '').localeCompare(String(b.name || ''), 'en-GB')
  );
}

export function isSchoolListAlphabetical(schools) {
  if (!schools || schools.length < 2) return true;
  for (let i = 1; i < schools.length; i += 1) {
    if (String(schools[i - 1].name || '').localeCompare(String(schools[i].name || ''), 'en-GB') > 0) {
      return false;
    }
  }
  return true;
}
